<template>
	<div>
		<loading v-if="!loaded" />
		<el-tabs v-model="tabName" v-if="loaded">
			<el-tab-pane label="អតិថិជនទាំងអស់" name="first"></el-tab-pane>
			<el-tab-pane label="បង្កើតអតិថិជនថ្មី" name="second"></el-tab-pane>
		</el-tabs>
		<div v-if="tabName == 'first' && loaded">
			<div class="md-layout">
				<div class="md-layout-item md-small-size-100 md-size-40">
					<md-field>
						<label>ស្វែងរកអតិថិជនដោយ​ឈ្មោះ លេខទូរស័ព្ទ ឬ លេខកូដ</label>
						<md-input v-model="search.text" type="text" @keyup.enter="searchHandler()"></md-input>
					</md-field>
				</div>

				<div class="md-layout-item md-size-30">
					<md-button class="md-raised md-primary" @click="searchHandler()" style="width: 100%">ស្វែងរក</md-button>
				</div>
			</div>

			<md-table v-if="clientList.length > 0">
				<md-table-row>
					<md-table-head>ល.រ</md-table-head>
					<md-table-head>លេខកូដ</md-table-head>
					<md-table-head>ឈ្មោះ</md-table-head>
					<md-table-head>លេខទូរស័ព្ទ</md-table-head>
					<md-table-head>ចំនួនរំលោះ</md-table-head>
					<md-table-head>កាលបរិច្ឆេទ</md-table-head>
					<md-table-head>សកម្មភាព</md-table-head>
				</md-table-row>

				<md-table-row v-for="(client, index) in clientList">
					<md-table-cell>{{ index + 1 }}</md-table-cell>
					<md-table-cell><b>{{ client.hash }}</b></md-table-cell>
					<md-table-cell>{{client.name}}</md-table-cell>
					<md-table-cell>{{ client.phone }}</md-table-cell>
					<md-table-cell>
						<b v-if="client.total_loan != null">{{client.total_loan}}</b>
						<b v-else>0</b> រំលោះ
					</md-table-cell>
					<md-table-cell>{{ config.datelify(client.created_date) }}</md-table-cell>
					<md-table-cell>
						<router-link :to="'/clients/detail/' + client.hash">
							<md-button class="md-just-icon md-simple md-success">
								<md-icon>visibility</md-icon>
								<md-tooltip md-direction="top">មើលលម្អិត</md-tooltip>
							</md-button>
						</router-link>

						<router-link :to="'clients/edit/'+ client.hash">
							<md-button class="md-just-icon md-simple md-info">
								<md-icon>edit</md-icon>
								<md-tooltip md-direction="top">កែប្រែព័ត៌មាន</md-tooltip>
							</md-button>
						</router-link>
						<md-button class="md-just-icon md-simple md-danger" @click="showDeleteAction(client.id)"  v-if="$store.state.authentication.account_type == 'sa'">
							<md-icon>close</md-icon>
							<md-tooltip md-direction="top">លុប</md-tooltip>
						</md-button>
					</md-table-cell>
				</md-table-row>
			</md-table>

			<h4 class="text-center" v-if="clientList.length == 0 && loadMore == true">មិនមានអតិថិជន!</h4>
			<div class="places-buttons text-right" v-if="loadMore">
				<md-button class="md-primary" @click="searchHandler(true)">បង្ហាញបន្ថែម</md-button>
			</div>
		</div>



		<div v-if="tabName == 'second'">
			<div class="md-layout">
				<div class="md-layout-item md-small-size-100 md-size-50">
					<div class="md-layout-item md-small-size-100 md-size-100">
						<h3>ព័ត៌មានអតិថិជន</h3>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-100 text-right">
						<span class="late">* តម្រូវបំពេញ</span>
					</div>
					<div class="md-layout">
						<div class="md-layout-item md-small-size-100 md-size-66">
							<md-field>
								<label>ឈ្មោះអតិថិជន *</label>
								<md-input type="text" v-model="client.name"></md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-33">
							<md-field>
								<label>ភេទ *</label>
								<md-select placeholder="ភេទ *" v-model="client.gender">
									<md-option value="f">ស្រី</md-option>
									<md-option value="m">ប្រុស</md-option>
									<md-option value="o">ផ្សេងៗ</md-option>
								</md-select>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-50">
							<md-field>
								<label>ថ្ងៃខែឆ្នាំកំណើត *</label>
								<md-input type="text" v-model="client.dob"></md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-50">
							<md-field>
								<label>លេខអត្តសញ្ញាណប័ណ្ណ *</label>
								<md-input type="text" v-model="client.id_card"></md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-50">
							<md-field>
								<label>លេខទូរស័ព្ទ *</label>
								<md-input type="text" v-model="client.phone"></md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-50">
							<md-field>
								<label>មុខរបរ *</label>
								<md-input type="text" v-model="client.occupation"></md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-100">
							<md-field>
								<label>អាសយដ្ឋាន</label>
								<md-input type="text" v-model="client.address">
								</md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-100">
							<md-field>
								<label>កំណត់ចំណាំ</label>
								<md-input type="text" v-model="client.note">
								</md-input>
							</md-field>
						</div>
					</div>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-50">
					<div class="md-layout-item md-small-size-100 md-size-100">
						<h3>ព័ត៌មានសង្ខេប</h3>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-100">
						<md-table>
							<md-table-row>
								<md-table-cell style="width: 50%;">ឈ្មោះអតិថិជន</md-table-cell>
								<md-table-cell style="width: 5px">:</md-table-cell>
								<md-table-cell>
									<span v-if="String(client.name).length > 0">{{client.name}}</span>
									<span v-else>N/A</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>ភេទ</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>
									<span v-if="String(client.gender).length > 0 && client.gender == 'm'">ប្រុស</span>
									<span v-else-if="String(client.gender).length > 0 && client.gender == 'f'">ស្រី</span>
									<span v-else-if="String(client.gender).length > 0 && client.gender == 'o'">ផ្សេងទៀត</span>
									<span v-else>N/A</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>ថ្ងៃខែឆ្នាំកំណើត</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>
									<span v-if="String(client.dob).length > 0">{{client.dob}}</span>
									<span v-else>N/A</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>មុខរបរ</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>
									<span v-if="String(client.occupation).length > 0">{{client.occupation}}</span>
									<span v-else>N/A</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>លេខទូរស័ព្ទ</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>
									<span v-if="String(client.phone).length > 0">{{client.phone}}</span>
									<span v-else>N/A</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>លេខអត្តសញ្ញាណប័ណ្ណ</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>
									<span v-if="String(client.id_card).length > 0">{{client.id_card}}</span>
									<span v-else>N/A</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>អាសយដ្ឋាន</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>
									<span v-if="String(client.address).length > 0">{{client.address}}</span>
									<span v-else>N/A</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>កំណត់ចំណាំ</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>
									<span v-if="String(client.note).length > 0">{{client.note}}</span>
									<span v-else>N/A</span>
								</md-table-cell>
							</md-table-row>
						</md-table>
					</div>
				</div>
				<div class="md-layout-item md-size-100 text-right">
					<md-button class="md-raised md-primary" @click="postClient()">បង្កើត</md-button>
				</div>
			</div>

		</div>
		<md-dialog-confirm :md-active.sync="deleteDialogActive" md-title="តើអ្នកពិតជាចង់លុបអតិថិជននេះមែនទេ ?"
			md-content="អតិថិជននេះនឹងត្រូវបានលុប។" md-confirm-text="លុប" md-cancel-text="បោះបង់"
			@md-cancel="onCancel" @md-confirm="onDelete" />
	</div>



</template>

<script>
	import { Datetime } from 'vue-datetime';
	export default {
		components: { Datetime },
		created() {
			window.scrollTo(0,0);
			this.searchHandler();

		},

		data() {
			return {
				tabName: "first",
				loaded: false,
				deleteDialogActive: false,
				deleteSelected: '',
				search: {
					text: "",
					gender: ""
				},
				client: {
					valid: false,
					name: "",
					phone: "",
					gender: "",
					note: "",
					dob: "",
					occupation: "",
					address: "",
					id_card: ""
				},
				loadMore: true,
				clientList: []

			}
		},
		methods: {
			postClient() {
				if (!this.checkValidation()) return false;
				this.$http.post(this.config.api + "/admin/client/post", {
					client: this.client
				}).then(data => {
					if (data.body.status == 'success') {
						this.tabName = 'first'
						this.$notification.notify({
							message: "អតិថិជនត្រូវបានបង្កើតឡើងដោយជោគជ័យ។",
							icon: 'done',
							type: 'success'
						});
						this.search.text = "";
						this.search.gender = "";
						this.searchHandler();
					}
					// this.loadMoreCompanyButton = true
					// this.memberList = data.body.data;
				})
			},
			searchHandler(more = false) {
				this.$http.post(this.config.api + "/admin/client/search", {
					text: this.search.text,
					gender: this.search.gender,
					offset: more ? this.clientList.length : 0
				}).then(data => {
					this.loaded = true;
					this.search.text = "";
					this.clientList = more ? this.clientList.concat(data.body.data) : data.body.data;
					if (data.body.data.length == 100) this.loadMore = true
					else this.loadMore = false
				})
			},
			checkValidation() {
				if (String(this.client.name).length > 0
					&& String(this.client.phone).length > 0 && String(this.client.gender).length > 0
					&& String(this.client.dob) && String(this.client.id_card) && String(this.client.occupation)) {
					return true;
				} else {
					this.$notification.notify({
						message: "សូមបំពេញព័ត៌មានបន្ថែម",
						icon: 'info',
						type: 'warning'
					});
					return false;
				}
			},
			clearAll() {
				this.search.text = "";
				this.search.gender = "";
				this.client = {
					valid: false,
					name: "",
					phone: "",
					gender: "",
					note: "",
					dob: "",
					occupation: "",
					address: "",
					id_card: ""
				}
			},
			showDeleteAction(id) {
				this.deleteSelected = id
				this.deleteDialogActive = true
			},
			onDelete() {
				this.$http.post(this.config.api + "/admin/client/delete", {
					id: this.deleteSelected
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "អតិថិជនត្រូវបានលុយដោយជោគជ័យ។",
							icon: 'done',
							type: 'success'
						})
						this.searchHandler();
						this.onCancel();
					}
				})
			},
			onCancel() {
				this.deleteSelected = ""
				this.deleteDialogActive = false
			}
		}
	}
</script>
<style scoped>
	.product-thumbnail {
		width: 64px;
		height: 64px;
	}

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		width: 50%;
	}

	.file-image-wrapper {
		/* margin: 10px; */
		width: calc(100%);
		padding-top: 8px;
		padding-bottom: 5px;
		border: 1px solid #ccc;
		border-radius: 5px;
	}

	.file-image {
		margin-top: 21px;
		text-align: center;
		/* margin-left: 10px;
		margin-right: 10px; */
		/* min-width: calc(33.3333% - 20px) !important;
		max-width: calc(33.3333% - 20px) !important;
		flex: 0 1 calc(33.3333% - 20px) !important; */
		/* padding: 0; */
	}
</style>



// WEBPACK FOOTER //
// src/pages/Clients/View.vue